import { Button } from 'antd';
import { AuthTranscription } from 'config/constants/transcription.constant';
import AuthIntentUtils from 'config/utils/auth-intent.util';
import NavigationUtils from 'config/utils/navigation.util';
import React from 'react';
import { useLocation } from 'react-router-dom';
import styles from './style.module.scss';

const SessionOverlay: React.FC = () => {
  const location = useLocation();

  const handleReopenLogin = () => {
    AuthIntentUtils.requireAuth({
      redirectTo: NavigationUtils.getLocationRedirectPath(location.pathname, location.search),
    });
  };

  return (
    <div className={styles['overlay']} role='presentation' onClick={(event) => event.stopPropagation()}>
      <div className={styles['dialog']} role='dialog' aria-labelledby='session-overlay-title' aria-modal='true'>
        <p id='session-overlay-title' className={styles['title']}>
          {AuthTranscription.ERROR_JWT_EXPIRED_RETRY_LOGIN}
        </p>
        <Button type='primary' className={styles['action']} onClick={handleReopenLogin}>
          {AuthTranscription.FORM_LOGIN_TEXT}
        </Button>
      </div>
    </div>
  );
};

export default SessionOverlay;
